import React, { useState, useEffect } from 'react';

const Search = ({ onChange }) => {
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState(searchValue);

    // Update debouncedValue after delay
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
        }, 500);

        // Cleanup function
        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    // Call onChange when debouncedValue changes
    useEffect(() => {
        if (onChange) {
            onChange(debouncedValue);
        }
    }, [debouncedValue, onChange]);

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    };

    return (
        <div className="pt-4">
            <div className="relative">
                <label htmlFor="Search" className="sr-only">
                    {' '}
                    Search{' '}
                </label>

                <input
                    type="text"
                    id="Search"
                    placeholder="Search for..."
                    className="w-full rounded-md border-gray-200 border-2 py-2.5 px-4 pe-10 sm:text-sm"
                    value={searchValue}
                    onChange={handleSearchChange}
                />

                <span className="pointer-events-none absolute inset-y-0 end-0 grid w-10 place-content-center text-gray-500">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="h-4 w-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                        />
                    </svg>
                </span>
            </div>
        </div>
    );
};

export default Search;
